import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Stack,
  Avatar,
  Paper,
  Divider,
  Fade,
} from '@mui/material'
import localization from '../utils/localization'
import UserUtils from '../utils/user'
import moment from 'moment'

function ModalUserInfo(props) {
  const [userInfo, setUserInfo] = useState(UserUtils.getUserInfo())

  useEffect(() => {
    if (props.open) setUserInfo(UserUtils.getUserInfo())
  }, [props.open])

  const infoItems = [
    {
      icon: 'icon-person',
      label: localization.strings.account,
      value: userInfo.account,
      color: '#1E88E5',
    },
    {
      icon: 'icon-lock',
      label: localization.strings.expiryTime,
      value: moment(userInfo.expiry_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
      color: '#4CAF50',
    },
  ]

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '28px',
          p: 1,
          overflow: 'hidden',
          backgroundColor: '#F8FAFC',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          textAlign: 'center',
          pt: 4,
          pb: 1,
          color: '#1E293B',
        }}
      >
        {localization.strings.userInfo}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 4 }}>
        <Fade in={props.open} timeout={500}>
          <Box>
            {/* Profile Header */}
            <Stack alignItems="center" sx={{ mb: 4, mt: 2 }}>
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  bgcolor: '#1E88E5',
                  fontSize: '2.5rem',
                  boxShadow: '0 12px 24px rgba(30, 136, 229, 0.2)',
                  mb: 2,
                }}
              >
                <i className="iconfont icon-person" style={{ fontSize: '2.5rem' }}></i>
              </Avatar>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: '#1E293B',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {userInfo.account?.split('@')[0]}
              </Typography>
            </Stack>

            <Stack spacing={2}>
              {infoItems.map((item, index) => (
                <Paper
                  key={index}
                  elevation={0}
                  sx={{
                    p: 2.5,
                    borderRadius: '20px',
                    border: '1px solid rgba(0,0,0,0.04)',
                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 16px rgba(0,0,0,0.04)',
                    },
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: '12px',
                        backgroundColor: `${item.color}10`,
                        color: item.color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i className={`iconfont ${item.icon}`} style={{ fontSize: '1.4rem' }}></i>
                    </Box>
                    <Box sx={{ flex: 1, overflow: 'hidden' }}>
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#94A3B8',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          display: 'block',
                          mb: 0.5,
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 700,
                          color: '#1E293B',
                          wordBreak: 'break-all',
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Box>
                  </Stack>
                </Paper>
              ))}
            </Stack>
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  )
}

export default ModalUserInfo
